export enum PlaceType {
  CITY = 'locality',
  DISTRICT = 'sublocality',
  DISTRICT_LEVEL_1 = 'sublocality_level_1',
  NEIGHBORHOOD = 'neighborhood',
  REGION = 'administrative_area_level_1',
  DEPARTMENT = 'administrative_area_level_2',
  POSTAL_CODE = 'postal_code',
  COUNTRY = 'country',
  STREET_ADDRESS = 'street_address',
  ROUTE = 'route',
}

export interface GoogleAddressPrediction {
  placeId: string,
  text: {
    text: string,
  };
}

export interface GooglePlaceResponse {
  placePrediction: GoogleAddressPrediction;
}

export interface GoogleAddressSuggestion {
  placeId: string,
  text: string,
}

export interface GoogleAddressLocation {
  latitude: number,
  longitude: number,
}

export interface GoogleLatLong {
  lat: number,
  lng: number,
}

export interface GoogleAddressResult extends GoogleAddressSuggestion {
  location: GoogleAddressLocation,
}

export interface GoogleGeometry {
  bounds?: {
    northeast: GoogleLatLong;
    southwest: GoogleLatLong;
  };
  location: GoogleLatLong;
  location_type?: string;
  viewport: {
    northeast: GoogleLatLong;
    southwest: GoogleLatLong;
  };
}

export interface GoogleAddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface GooglePlace {
  address_components: GoogleAddressComponent[];
  formatted_address: string;
  geometry: GoogleGeometry;
  place_id: string;
  types: string[];
  placeType?: PlaceType | null;
}

export interface GoogleGeocodingResponse {
  status: number;
  results: GooglePlace[];
}

export interface GoogleAutocompleteResponse {
  suggestions: GooglePlaceResponse[];
}
